module.exports = "<p>\n  password works!\n</p>\n"